{
    "Messages_Type_Label": "Message type",
    "Messages_Language_Label": "Language",
    "Messages_Language_DefaultOption": "Default / Fallback",
    "Messages_Subject_Label": "Subject",
    "Messages_PlainBody_Label": "Body (plain text)",
    "Messages_HtmlBody_Label": "Body (HTML)",
    "Messages_NewLocale_Info": "A new message entry will be created for this language when you save.",
    "Messages_Action_Save": "Save",
    "Messages_Action_Revert": "Revert",
    "Messages_Action_Delete": "Delete",
    "Messages_DiscardChanges_Prompt": "Discard unsaved changes?",
    "Messages_DiscardChanges_Confirm": "Discard changes",
    "Messages_DiscardChanges_Cancel": "Keep editing",
    "Messages_Save_Success": "Message saved.",
    "Messages_Save_Error": "Unable to save the message.",
    "Messages_Delete_Success": "Message deleted.",
    "Messages_Delete_Error": "Unable to delete the message.",
    "NAME": "MessagesLanguage"
}
